import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { AmountActions } from './amount.actions';
import { IAmountState } from './amount.state';

export const initialAmountState: IAmountState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const amountReducerFn = createReducer(
  initialAmountState,
  on(AmountActions.reset, (state: IAmountState, action) => {
    return new StateBuilder<IAmountState>(initialAmountState).build();
  }),
  on(AmountActions.load, (state: IAmountState, action) => {
    return new StateBuilder<IAmountState>(state).toLoading().build();
  }),
  on(AmountActions.loadSuccess, (state: IAmountState, action) => {
    return new StateBuilder<IAmountState>(state, action).toLoaded().build();
  }),
  on(AmountActions.submit, (state: IAmountState) => {
    return new StateBuilder<IAmountState>(state).toLoading().build();
  }),
  on(AmountActions.submitSuccess, (state: IAmountState, action) => {
    return new StateBuilder<IAmountState>(state, action).toLoaded().build();
  })
);

export function amountReducer(state: IAmountState | undefined, action: Action) {
  return amountReducerFn(state, action);
}
